(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
const targetNode = document.querySelector("body .t4s-container");

// Options for the observer (which mutations to observe)
const config = { childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if(mutation.target.parentElement.classList.contains("cbb-shipping-rates-calculator")){
      mutation.target.parentElement.remove()
    }
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presidents-sale-announcement"]) return;
  try {
    

  if (!customElements.get('promo-bar')) {
    class PromoBar extends HTMLElement {
      constructor() {
        super()
        this.targets = this.querySelectorAll('.promoBar__message[data-copied-element]')
      }

      connectedCallback(){
        if (this.targets.length > 0) {
          Array.from(this.targets).forEach((target) => {
            target.onclick = function () {
              document.execCommand('copy');
            };

            target.addEventListener('copy', function (event) {
              event.preventDefault();
              if (event.clipboardData) {
                event.clipboardData.setData('text/plain', target.dataset.value);
                console.log(event.clipboardData.getData('text'));
              }
            });
          });
        }
      }
    }

    customElements.define("promo-bar", PromoBar)
  }

  } catch(e) { console.error(e); }
})();
})();
